// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"5f0fa4dd","454":"d316e162","520":"dee847da","553":"8157d6c2","653":"916f620b","854":"61db1d07","858":"5958c7a9"}[chunkId] + ".chunk.js";
};